export const maxCartAdditionAmount = 999;
